import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContractService } from '../../contract.service';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import { AuthService } from '../../../../../../core/services/auth.service';
import { switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { distinctUntilChangedDeep } from '../../../../../../core/utils/rxjs.utils';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ProductModel } from '../../../../../../core/models/product.model';
import { ProductContractCreateUpdateDeleteComponent } from '../../../product/product-contract-create-update-delete/product-contract-create-update-delete.component';
import { PrestationContractCreateUpdateDeleteComponent } from '../../../prestation/prestation-contract-create-update-delete/prestation-contract-create-update-delete.component';
import { PrestationModel } from '../../../../../../core/models/prestation.model';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ContractBaseComponent } from '../contract-base/contract-base.component';
import { ContractBasketCreateUpdateDeleteComponent } from '../../modals/contract-basket-create-update-delete/contract-basket-create-update-delete.component';
import { ContractModel, ContractPerimeterModel } from '../../../../../../core/models/contract.model';
import { PrestationService } from '../../../prestation/prestation.service';
import { ProductService } from '../../../product/product.service';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import icDone from '@iconify/icons-ic/twotone-done';
import icClose from '@iconify/icons-ic/twotone-close';
import { ContractStatusEnum } from '../../../../../../core/enums/contract-status.enum';
import { InterventionTypeEnum } from '../../../../../../core/enums/intervention.enum';
import { TvaService } from '../../../../settings/tva/tva.service';
import { TvaModel } from '../../../../../../core/models/tva.model';
import { Observable, Subject, Subscription } from 'rxjs';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';
import { EstablishmentCreateUpdateDeleteComponent } from '../../../establishment/modals/establishment-create-update-delete/establishment-create-update-delete.component';
import { EstablishmentModel } from '../../../../../../core/models/establishment.model';
import { ObjectApiInterface } from '../../../../../../core/base/interfaces/object-api.interface';

@Component({
  selector: 'vex-contract-details-catalog',
  templateUrl: './contract-details-catalog.component.html',
  styleUrls: ['./contract-details-catalog.component.scss'],
})
export class ContractDetailsCatalogComponent extends ContractBaseComponent implements OnInit, OnDestroy {
  feisColumnsArticle: Array<FeiColumn> = [
    { label: 'Référence', column: 'reference', type: 'custom', width: '110px' },
    { label: 'Libellé', column: 'label', wrap: true, width: '30%', minWidth: '250px' },
    { label: 'Périmètre complet', column: 'isFullPerimeter', type: 'custom', width: '150px' },
    // {label: 'Article', column: 'genericProduct', propertyDisplay: 'genericProduct.label'},
    { label: 'Quantité Minimum', column: 'minQuantity', width: '150px' },
    {
      label: 'Coût article contrat HT (Prix HT)',
      column: 'priceHT',
      type: 'number',
      additionalDisplay: '€',
      width: '250px',
    },
    {
      label: 'Taux TVA',
      column: 'tva',
      type: 'custom',
      width: '100px',
    },
    {
      label: 'Coût article contrat TTC (Prix TTC)',
      column: 'priceTTC',
      type: 'number',
      additionalDisplay: '€',
      width: '255px',
    },
    {
      label: 'Condition de révision (en %)',
      type: 'number',
      column: 'revisionAmount',
      additionalDisplay: ' %',
      maxDecimal: 2,
      width: '230px',
    },
    { label: 'Visibilité e-Shop', column: 'isSuspended', type: 'eshopStatus', width: '150px' },
    { label: 'Action', column: 'actions', canUpdate: true, canArchive: false, canDelete: false, canSuspend: true },
  ];

  feisColumnsPrestation: Array<FeiColumn> = [
    { label: 'Référence', column: 'reference', type: 'custom', width: '110px' },
    { label: 'Libellé', column: 'label', wrap: true, width: '30%', minWidth: '250px' },
    { label: 'Périmètre', column: 'isFullPerimeter', type: 'custom', width: '100px' },
    // {label: 'Prestation', column: 'genericPrestation', propertyDisplay: 'genericPrestation.label'},
    { label: 'Quantité Minimum', column: 'minQuantity', width: '150px' },
    {
      label: 'Coût prestation contrat HT (Prix HT)',
      column: 'priceHT',
      type: 'number',
      additionalDisplay: '€',
      width: '260px',
    },
    {
      label: 'Taux TVA',
      column: 'tva',
      type: 'custom',
      width: '100px',
    },
    {
      label: 'Coût prestation contrat TTC (Prix TTC)',
      column: 'priceTTC',
      type: 'number',
      additionalDisplay: '€',
      width: '265px',
    },
    {
      label: 'Condition de révision (en %)',
      type: 'number',
      column: 'revisionAmount',
      additionalDisplay: ' %',
      maxDecimal: 2,
      width: '230px',
    },
    { label: 'Nombre Prestations au forfait', column: 'purchasePackageValue', type: 'text', width: '235px' },
    { label: "Nombre d'interventions initial", column: 'purchaseValueToDisplay', type: 'text', width: '240px' },
    { label: 'Solde de prestations', column: 'purchaseValueRemaining', type: 'text', width: '175px' },
    { label: 'Visibilité e-Shop', column: 'isAvailable', type: 'eshopStatus', width: '150px' },
    { label: 'Intervention planifiée', column: 'interventionRequired', type: 'custom', width: '190px' },
    { label: 'Date de dernière intervention', column: 'lastInterventionDate', type: 'date', width: '235px' },
    { label: 'Action', column: 'actions', canUpdate: true, canArchive: true, canDelete: true },
  ];

  feisColumns: Array<FeiColumn>;
  tooltip = false;
  showPreviousReference = false;
  ContractStatusEnum = ContractStatusEnum;
  icClose = icClose;
  icDone = icDone;
  prestations;
  previousId;
  perimeter: ContractPerimeterModel[] = [];
  contract: ContractModel;
  isFullPerimter: boolean;
  stockedData: any[] = [];
  isPredikUser = false;
  genericProduct = null;
  genericPrestation = null;
  protected readonly InterventionTypeEnum = InterventionTypeEnum;
  hideTooltipTimeout: any;
  private filterChange$ = new Subject<any>();
  private destroy$ = new Subject<void>();

  constructor(
    public contractService: ContractService,
    public prestationService: PrestationService,
    public authService: AuthService,
    private dialog: MatDialog,
    public productService: ProductService,
    public snackbarService: SnackbarService,
    private tvaService: TvaService,
  ) {
    super(contractService, productService, prestationService, authService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initData();
    this.setupFilterStream();
  }

  initData() {
    super.initData();

    this.contractService.entity$.subscribe((contract: ContractModel) => {
      this.isEditableCatalog = this.contractService.checkIsEditableCatalog(this.contract);
      if (this.contract.status === ContractStatusEnum.DRAFT) {
        this.feisColumnsArticle = this.updateActionsColumnDraft(this.feisColumnsArticle);
        this.feisColumnsPrestation = this.updateActionsColumnDraft(this.feisColumnsPrestation);
      }
      if (!this.isEditableCatalog) {
        this.feisColumnsArticle = this.updateActionsColumn(this.feisColumnsArticle);
        this.feisColumnsPrestation = this.updateActionsColumn(this.feisColumnsPrestation);
      }

      // Apply canSuspend rule based on user permissions
      this.updateCanSuspendRule();

      // PRED-3230 : les actions de ligne suivent les droits Engagement (modifier / supprimer).
      this.feisColumnsArticle = this.applyContractPermissionsToActions(this.feisColumnsArticle);
      this.feisColumnsPrestation = this.applyContractPermissionsToActions(this.feisColumnsPrestation);

      // If you have any other logics to add for the catalog about a internal contract, thanks to add it in this function :
      this.internalContractLogic(contract);
    });
    this.isPredikUser = this.authService.checkCurrentIsPredik();

    const subCheckPermissions = this.checkPermissions().subscribe();
    this.subscription.add(subCheckPermissions);
  }

  updateActionsColumn(columns: Array<FeiColumn>) {
    return columns.map(column => {
      if (column.column === 'actions') {
        // column.canUpdate = false;
        column.canArchive = this.contract?.status !== ContractStatusEnum.EXPIRED;
        column.canDelete = false;
      }
      return column;
    });
  }

  onStockData(data) {
    this.stockedData = data;
  }

  getTvaRate(tva: TvaModel) {
    const rateList = this.tvaService.getRateByDate(tva)?.rate.toFixed(2);
    return `${rateList ? rateList + '%' : '-'}`;
  }

  private setupFilterStream(): void {
    this.filterChange$
      .pipe(
        distinctUntilChangedDeep(),
        switchMap(filtersData => {
          this.loading = true;
          const search = filtersData.search ? filtersData.search : '';
          const stockable = filtersData.filters?.stockable ? filtersData.filters?.stockable : null;
          const isSuspended = filtersData.filters?.isSuspended != null ? filtersData.filters?.isSuspended : null;
          const filters = {
            contractId: this.contract._id,
            isAllEstablishment: true,
            isWithExpired: true,
            requiredFields: ['*'],
            stockable,
            isSuspended,
          };

          if (this.hasArticle && this.entityType === 'products') {
            return this.productService.findAll(this.pageIndex, this.pageSize, 'label', 'asc', search, {
              ...filters,
              genericProduct: filtersData.genericProduct,
            });
          } else if (!this.hasArticle && this.entityType === 'prestations') {
            return this.prestationService.findAll(this.pageIndex, this.pageSize, 'label', 'asc', search, filters);
          }
          return [];
        }),
        takeUntil(this.destroy$),
      )
      .subscribe(
        res => {
          if (this.hasArticle && this.entityType === 'products') {
            this.countProduct = res.totalData;
            this.products = res.data;
            this.dataSourceArticle = new MatTableDataSource<ProductModel>(res.data);
            this.articleEmpty = res.totalData === 0;
          } else if (!this.hasArticle && this.entityType === 'prestations') {
            this.countPrestation = res.totalData;
            this.prestations = res.data;
            this.dataSourcePrestation = new MatTableDataSource<PrestationModel>(res.data);
            this.prestationEmpty = res.totalData === 0;
          }
          this.loading = false;
        },
        error => {
          console.error('Error loading catalog:', error);
          this.loading = false;
        },
      );
  }

  onFilterEvent(filtersData: any) {
    this.filterChange$.next(filtersData);

    if (filtersData.search === '') {
      this.prestationEmpty = false;
      this.articleEmpty = false;
    }
  }

  countFilteredItems(dataSource: MatTableDataSource<any>, filterValue: any) {
    return dataSource.data.filter(item => dataSource.filterPredicate(item, filterValue)).length;
  }

  checkPermissions() {
    return this.authService.getCurrentUserPermissions$().pipe(
      tap((permissions: any) => {
        // this.canUpdateAndAddPermission = permissions.includes(ENUM_PERMISSIONS.INPUT_FM_REF_PURCHASE_COMMITMENT_CATALOG);
        // this.canUpdateQuantityPermission = permissions.includes(ENUM_PERMISSIONS.UPDATE_FM_REF_PURCHASE_COMMITMENT_CATALOG);
        // this.canDeletePermission = permissions.includes(ENUM_PERMISSIONS.DELETE_FM_REF_PURCHASE_COMMITMENT_CATALOG);
        // this.canAddPanierContratPermission = permissions.includes(ENUM_PERMISSIONS.ADD_FM_REF_PURCHASE_COMMITMENT_CATALOG);
      }),
    );
  }

  createPrestIntervention(row) {
    const dialogRef = this.dialog.open(ContractBasketCreateUpdateDeleteComponent, {
      data: {
        mode: CrudModeEnum.Create,
        contract: this.contract,
        prestInterventionId: row._id,
        prestInterventionRequired: row.interventionRequired,
        prestLabel: row.label,
        contractGenericEngagementDataPatrimony: this.contract.genericEngagement.dataPatrimony,
      },
    });
    dialogRef.afterClosed().subscribe({});
  }

  createContractItem() {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    const sub = this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          mode: CrudModeEnum.Create,
          contract: this.contract,
          messageResult:
            this.entityType === 'products'
              ? "L'article a été ajouté avec succès"
              : 'La prestation a été ajoutée avec succès',
        },
      })
      .afterClosed()
      .subscribe((elements: ProductModel[] | PrestationModel[]) => {
        if (elements) {
          this.initDataSources();
          this.contractService.setIsValid(true);
        }
      });
    this.subscription.add(sub);
  }

  importContractItems(isQuoteUpdate: boolean = false) {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    const sub = this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          mode: CrudModeEnum.Import,
          contract: this.contract,
          isQuoteUpdate: isQuoteUpdate,
        },
      })
      .afterClosed()
      .subscribe((elements: ProductModel[] | PrestationModel[]) => {
        if (elements) {
          this.initDataSources();
          this.contractService.setIsValid(true);
          const resultMessage: string =
            this.entityType === 'products'
              ? 'Les articles ont été importés avec succès'
              : 'Les prestations ont été importé(e)s avec succès';
          this.snackbarService.success(resultMessage);
        }
      });
    this.subscription.add(sub);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.filterChange$.complete();
  }

  updateItem(element: ProductModel | PrestationModel): void {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;
    this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          defaults: element,
          mode: CrudModeEnum.Update,
          contract: this.contract,
          messageResultUpdate:
            this.entityType === 'products'
              ? "L'article a été modifié avec succès"
              : 'La prestation a été modifiée avec succès',
        },
      })
      .afterClosed()
      .subscribe(element => {
        if (element) {
          this.initDataSources();
        }
      });
  }

  archiveItem(element: ProductModel | PrestationModel) {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          defaults: element,
          name: `${element.label}`,
          mode: CrudModeEnum.Archive,
        },
      })
      .afterClosed()
      .subscribe(element => {
        if (element) {
          this.initDataSources();
        }
      });
  }

  deleteItem(element: ProductModel | PrestationModel) {
    let defaultMessage = `Êtes-vous sûr de vouloir supprimer ${element.label} ?`;

    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    // Check if the reference exist in recurringBasket
    const subscription: Subscription = this.contractService.reccuringBaskets$
      .pipe(take(1))
      .subscribe(recurringBaskets => {
        const exists = recurringBaskets.some(recurringBasket => {
          const items = recurringBasket[this.entityType];
          return items?.some(item => (item.item as ProductModel | PrestationModel)._id === element._id);
        });

        if (exists) {
          defaultMessage = `Cette référence se trouve dans l'un de vos paniers contrat. Êtes-vous sûr de vouloir supprimer ?`;
        }

        this.dialog
          // @ts-ignore
          .open(component, {
            data: {
              defaults: element,
              name: `${element.label}`,
              mode: CrudModeEnum.Delete,
              defaultMessage,
            },
          })
          .afterClosed()
          .subscribe(
            result => {
              if (result) {
                this.initDataSources();

                this.snackbarService.success(
                  this.entityType === 'products'
                    ? 'Le produit a bien été supprimé'
                    : 'La prestation a bien été supprimée',
                );
              }
            },
            error => {
              this.snackbarService.warning('Une erreur est survenue');
            },
          );

        subscription.unsubscribe();
      });
  }

  isToPlan(element): boolean {
    if (element.genericPrestation?.interventionRequired && !(element.interventionType === InterventionTypeEnum.FIXE)) {
      return true;
    } else {
      return false;
    }
  }

  isExistingIntervention(element): boolean {
    if (this.contract?.recurringBasket?.find(x => x.prestation?._id === element._id)) {
      return true;
    } else {
      return false;
    }
  }

  showTooltipText(element): boolean {
    if (element.interventionType === InterventionTypeEnum.FIXE && element.isPackageService) {
      return true;
    } else {
      return false;
    }
  }

  getTooltipText(element: any): string {
    return `Compteur d'intervention : ${element.purchaseValueRemaining}\n`;
  }

  updateActionsColumnDraft(columns: Array<FeiColumn>) {
    return columns.map(column => {
      if (column.column === 'actions') {
        column.canArchive = false;
        column.canDelete = true;
      }
      return column;
    });
  }

  showTooltip(state: boolean, element?) {
    if (!state) {
      this.tooltip = false;
      this.previousId = '';
    } else if (element?._id && this.previousId !== element?._id) {
      this.tooltip = true;
      this.perimeter = element.perimeter;
      this.isFullPerimter = element.isFullPerimeter;
      this.previousId = element?._id;
    }
  }

  onMouseEnter(row) {
    this.clearHideTooltipTimeout();
    this.showTooltip(true, row);
  }

  onMouseLeave() {
    this.setHideTooltipTimeout();
  }

  onMouseEnterTooltip() {
    this.clearHideTooltipTimeout();
  }

  onMouseLeaveTooltip() {
    this.setHideTooltipTimeout();
  }

  setHideTooltipTimeout() {
    this.hideTooltipTimeout = setTimeout(() => {
      this.showTooltip(false);
    }, 300);
  }

  clearHideTooltipTimeout() {
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
      this.hideTooltipTimeout = null;
    }
  }

  internalContractLogic(contract: ContractModel) {
    if (contract?.supportEstablishment) {
      this.feisColumnsArticle = this.removePerimeterColumn(this.feisColumnsArticle);
      this.feisColumnsPrestation = this.removePerimeterColumn(this.feisColumnsPrestation);
    }
  }

  removePerimeterColumn(columns: FeiColumn[]): FeiColumn[] {
    return columns.filter(col => col.column !== 'isFullPerimeter');
  }

  importModificationContractItems() {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    const sub = this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          mode: CrudModeEnum.Import,
          contract: this.contract,
          modificationImportItem: true,
        },
      })
      .afterClosed()
      .subscribe((elements: ProductModel[] | PrestationModel[]) => {
        if (elements) {
          this.initDataSources();
          this.contractService.setIsValid(true);
          const resultMessage: string =
            this.entityType === 'products'
              ? 'Les articles ont été modifié avec succès'
              : 'Les prestations ont été modifiées avec succès';
          this.snackbarService.success(resultMessage);
        }
      });
    this.subscription.add(sub);
  }

  exportContractItems() {
    const service = this.entityType === 'products' ? this.productService : this.prestationService;
    const entityName = this.entityType === 'products' ? 'articles' : 'prestations';

    const sub = service.downloadExcelTemplateProductContractModificationItem(this.contract._id).subscribe({
      next: (res: any) => {
        if (res && res.data && res.data.b64) {
          const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.b64}`;
          const downloadLink = document.createElement('a');
          const fileName = `Export_${entityName}_${this.contract.technicalIdentifier}_${new Date().toISOString().split('T')[0]}.xlsx`;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();

          this.snackbarService.success(`Export des ${entityName} réussi`);
        } else {
          this.snackbarService.warning("Erreur lors de l'export");
        }
      },
      error: error => {
        console.error("Erreur lors de l'export:", error);
        this.snackbarService.warning("Une erreur est survenue lors de l'export");
      },
    });

    this.subscription.add(sub);
  }
}
